var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertDataToSelectOptions, convertDataToSelectOptionsBVlocations } from '../utils/commonUtil';
import { fetchDataGetReq, fetchDataPostReq, fetchDataPutReq } from '../apis/apiUtil';
import { certRenewalStatus } from '../config/BVConstants';
import { certStatusOptions } from '../models/StatusOptions';
export function getCertFilterSectionData(applicationData, selCertStatus, setSelCertStatus, selBrandList, setSelBrandList, selLstBVLocation, setSelLstBVLocation, selCountryTerritoryList, setSelCountryTerritoryList, selProductTypeList, setSelProductTypeList, selServiceTypeList, setSelServiceTypeList, selCertRenewStatusList, setSelCertRenewStatusList, selIssueDateRange, setSelIssueDateRange, selExpDateRange, setSelExpDateRange, selRenDecisionDtRange, setSelRenDecisionDtRange, 
//quick search 
selIntValidityOptionType, setSelIntValidityOptionType, selIntExpiryCountId, setSelIntExpiryCountId, selIntRenewalCountId, setSelIntRenewalCountId, 
//quicksearch end
handleClearAllAppliedFilters) {
    return {
        name: 'cert_filter_panel',
        selectOptionsList: selectOptionsList(selCertStatus, setSelCertStatus),
        multiSelectList: [
            multiSelectObj('Brand/OEM', selBrandList, setSelBrandList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.brandNamesCertProjects),
            multiSelectObjBVlocations('BV Location', selLstBVLocation, setSelLstBVLocation, applicationData === null || applicationData === void 0 ? void 0 : applicationData.bvCertLocations),
            multiSelectObj('Country/Territory', selCountryTerritoryList, setSelCountryTerritoryList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.countryTerritoryList),
            multiSelectObj('Product', selProductTypeList, setSelProductTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.productTypeList),
            multiSelectObj('Service Type', selServiceTypeList, setSelServiceTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.serviceTypeList),
            multiSelectObj('Renewal Status', selCertRenewStatusList, setSelCertRenewStatusList, certRenewalStatus)
        ],
        dateRangeOptions: [
            dateRangeObj('Issue Date', selIssueDateRange, setSelIssueDateRange),
            dateRangeObj('Expiration Date', selExpDateRange, setSelExpDateRange),
            dateRangeObj('Decision Date', selRenDecisionDtRange, setSelRenDecisionDtRange)
        ],
        quickSearchExpiryCountIdOptions: [
            searchOptionsObj(270, "OverDue", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(265, "1-10 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(260, "11-30 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(250, "31-60 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(240, "61-90 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(230, "91-180 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(220, "Over 180 Days", selIntExpiryCountId, setSelIntExpiryCountId),
            searchOptionsObj(290, "ALL", selIntExpiryCountId, setSelIntExpiryCountId)
        ],
        quickSearchRenewalCountIdOptions: [
            searchOptionsObj(170, "OverDue", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(165, "1-10 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(160, "11-30 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(150, "31-60 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(140, "61-90 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(130, "91-180 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(120, "Over 180 Days", selIntRenewalCountId, setSelIntRenewalCountId),
            searchOptionsObj(190, "ALL", selIntRenewalCountId, setSelIntRenewalCountId)
        ],
        quickSearchIntValidityOptionTypeOptions: [
            searchOptionsObj(1, "Recommended Decision Date", selIntValidityOptionType, setSelIntValidityOptionType),
            searchOptionsObj(2, "Certificate Expiration Date", selIntValidityOptionType, setSelIntValidityOptionType),
        ],
        handleClearAll: handleClearAllAppliedFilters
    };
}
export function searchOptionsObj(key, title, sel, setSelIntExpiryCountId) {
    return {
        data: {
            key: key,
            title: title,
            value: sel,
            setValue: setSelIntExpiryCountId
        }
    };
}
export function dateRangeObj(title, selIssueDateRange, setSelIssueDateRange) {
    return {
        dateRange: {
            title: title,
            value: selIssueDateRange,
            setValue: setSelIssueDateRange
        }
    };
}
export function multiSelectObj(title, selList, setSelList, jsonData) {
    return {
        multiSelect: {
            data: convertDataToSelectOptions(jsonData),
            title: title,
            value: selList,
            setValue: setSelList
        }
    };
}
export function multiSelectObjBVlocations(title, selList, setSelList, jsonData) {
    return {
        multiSelect: {
            data: convertDataToSelectOptionsBVlocations(jsonData),
            title: title,
            value: selList,
            setValue: setSelList
        }
    };
}
export function selectOptionsList(selCertStatus, setSelCertStatus) {
    return [
        {
            selectOptions: {
                data: certStatusOptions,
                title: 'Filter By Certificate Status',
                value: selCertStatus,
                setValue: (val) => setSelCertStatus(val)
            }
        }
    ];
}
export function searchCertificatesCount(data) {
    const url = `searchCertificatesReactCount`;
    return fetchDataPutReq(url, data);
}
export function searchCertificates(data) {
    const url = `searchCertificatesReact`;
    return fetchDataPutReq(url, data);
}
export function searchCertificatesRenewalReqReact(data) {
    const url = `searchCertificatesRenewalReqReact`;
    return fetchDataPutReq(url, data);
}
export function processRenewalsReact(data) {
    const url = `processRenewalsReact`;
    return fetchDataPutReq(url, data);
}
export function getListcertCancelReason() {
    const url = `getListcertCancelReason`;
    return fetchDataGetReq(url);
}
export function certificateCancelReact(data) {
    const url = `certificateCancelReact`;
    return fetchDataPutReq(url, data);
}
export function getCertSearchSuggestions(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `getCertSearchSuggestions`;
        return fetchDataPostReq(url, data);
    });
}
export function getScheduledCount(artifacts) {
    var _a, _b;
    let inprogSchedulecount = 0;
    for (const item of artifacts) {
        if (((item === null || item === void 0 ? void 0 : item.riskStatusId) == 1) && ((_a = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _a === void 0 ? void 0 : _a.intId) == 30002 || ((_b = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _b === void 0 ? void 0 : _b.intId) == 30006) {
            inprogSchedulecount++;
        }
    }
    return inprogSchedulecount;
}
export function getScheduledRiskCount(artifacts) {
    var _a, _b;
    let count = 0;
    for (const item of artifacts) {
        if ((((_a = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _a === void 0 ? void 0 : _a.intId) == 30002 && (item === null || item === void 0 ? void 0 : item.riskStatusId) == 2) || ((_b = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _b === void 0 ? void 0 : _b.intId) == 30006) {
            count++;
        }
    }
    return count;
}
export function getOnHoldCounts(artifacts) {
    var _a, _b;
    let count = 0;
    for (const item of artifacts) {
        if (((_a = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _a === void 0 ? void 0 : _a.intId) == 30007 || ((_b = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _b === void 0 ? void 0 : _b.intId) == 30003) {
            count++;
        }
    }
    return count;
}
export function getCancelCounts(artifacts) {
    var _a;
    let count = 0;
    for (const item of artifacts) {
        if (((_a = item === null || item === void 0 ? void 0 : item.objProjectStatus) === null || _a === void 0 ? void 0 : _a.intId) == 30005) {
            count++;
        }
    }
    return count;
}
export function getDasboardStats(scheduledCount, scheduledCountIcon, onRiskCount, onRiskCountIcon, onHoldCount, onHoldCountIcon, cancelledCount, cancelledCountIcon) {
    return [
        {
            title: 'In-Progress/On Schedule',
            value: scheduledCount,
            icon: scheduledCountIcon,
            index: 0,
            keys: 30002,
            R: 1,
        },
        {
            title: 'In-Progress/On Risk',
            value: onRiskCount,
            icon: onRiskCountIcon,
            index: 2,
            keys: 30002,
            R: 2,
        },
        {
            title: 'On Hold',
            value: onHoldCount,
            icon: onHoldCountIcon,
            index: 1,
            keys: 30003,
            R: null
        },
        {
            title: 'Cancelled',
            value: cancelledCount,
            icon: cancelledCountIcon,
            index: 3,
            keys: 30005,
            R: null
        }
    ];
}
class CertificateService {
    getCertificateDetails(data) {
        const url = `getCertificateDetails`;
        return fetchDataPutReq(url, data);
    }
    getClientDirectCertProductFamily(data) {
        const url = `getLstUploadProductFamily`;
        return fetchDataPutReq(url, data);
    }
    getCertProductFamily(data) {
        const url = `getLstProductFamilyForCert`;
        return fetchDataPutReq(url, data);
    }
    getApiRegLibCertMpCount(data) {
        const url = `getRegInfoForDirectUploadedCertCount`;
        return fetchDataPutReq(url, data);
    }
    getApiRegLibCertMpLazy(data) {
        const url = `getRegInfoForDirectUploadedCertLazy`;
        return fetchDataPutReq(url, data);
    }
    getLinkedRenewalCertificate(data) {
        const url = `getLstLinkedRenewalCert`;
        return fetchDataPutReq(url, data);
    }
    updateLinkedRenewalStatus(data) {
        const url = `updateLinkedRenewalStatus`;
        return fetchDataPutReq(url, data);
    }
    saveClientCertUpload(data) {
        const url = `saveClientCertUpload`;
        return fetchDataPostReq(url, data);
    }
    deleteApprCertUploadInfo(data) {
        const url = `deleteApprCertUploadInfo`;
        return fetchDataPutReq(url, data);
    }
    getDirectCertificateDetails(data) {
        const url = `getApprCertUploadInfoDetails`;
        return fetchDataPutReq(url, data);
    }
    saveDocument(data) {
        const url = `saveDocument`;
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        return fetchDataPostReq(url, data, headers);
    }
    getApprCertUploadInfoDetails(data) {
        const url = `getApprCertUploadInfoDetails`;
        return fetchDataPutReq(url, data);
    }
    getFileDocument(data) {
        const url = `getFileDocument`;
        return fetchDataPutReq(url, data);
    }
    deleteDocument(data) {
        const url = `deleteDocument`;
        return fetchDataPutReq(url, data);
    }
}
const certificateService = new CertificateService();
export default certificateService;
